module.exports = __webpack_public_path__ + "static/media/positioning-research.f43a0763.jpeg";